import { render } from "./Content.vue?vue&type=template&id=ab8eb33e&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=ab8eb33e&scoped=true&lang=css"

import exportComponent from "/Users/longpp/Desktop/klubcoin/universal-link/landing-page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab8eb33e"]])

export default __exports__